import { render, staticRenderFns } from "./StatisticByInstructorPermanentOutsource.vue?vue&type=template&id=2732a2c5&scoped=true"
import script from "./StatisticByInstructorPermanentOutsource.vue?vue&type=script&lang=ts"
export * from "./StatisticByInstructorPermanentOutsource.vue?vue&type=script&lang=ts"
import style0 from "./StatisticByInstructorPermanentOutsource.vue?vue&type=style&index=0&id=2732a2c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732a2c5",
  null
  
)

export default component.exports